<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-3">
                <ImageParamsComponent @paramsChanged="onParamsChanged" />
            </div>
            <div class="col-sm-9 ps-3">
                <ImagePreviewComponent :params="params" />
            </div>
        </div>
    </div>
</template>

<script>
import ImageParamsComponent from './ImageParamsComponent.vue';
import ImagePreviewComponent from './ImagePreviewComponent.vue';

export default {
    name: 'ImageConstructorComponent',
    components: { ImagePreviewComponent, ImageParamsComponent },
    data: function () {
        return {
            params: null,
        };
    },
    methods: {
        onParamsChanged(params) {
            this.params = params;
        },
    },
};
</script>

<style scoped></style>
